/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesMembersEditRights } from './WebApiModelsEnumerationTypesMembersEditRights';
import {
    WebApiModelsEnumerationTypesMembersEditRightsFromJSON,
    WebApiModelsEnumerationTypesMembersEditRightsFromJSONTyped,
    WebApiModelsEnumerationTypesMembersEditRightsToJSON,
} from './WebApiModelsEnumerationTypesMembersEditRights';

/**
 * 
 * @export
 * @interface WebApiCustomListsDtoUpdateCustomListDto
 */
export interface WebApiCustomListsDtoUpdateCustomListDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiCustomListsDtoUpdateCustomListDto
     */
    name?: string | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesMembersEditRights}
     * @memberof WebApiCustomListsDtoUpdateCustomListDto
     */
    membersEditRights?: WebApiModelsEnumerationTypesMembersEditRights;
}

/**
 * Check if a given object implements the WebApiCustomListsDtoUpdateCustomListDto interface.
 */
export function instanceOfWebApiCustomListsDtoUpdateCustomListDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiCustomListsDtoUpdateCustomListDtoFromJSON(json: any): WebApiCustomListsDtoUpdateCustomListDto {
    return WebApiCustomListsDtoUpdateCustomListDtoFromJSONTyped(json, false);
}

export function WebApiCustomListsDtoUpdateCustomListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiCustomListsDtoUpdateCustomListDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'membersEditRights': !exists(json, 'membersEditRights') ? undefined : WebApiModelsEnumerationTypesMembersEditRightsFromJSON(json['membersEditRights']),
    };
}

export function WebApiCustomListsDtoUpdateCustomListDtoToJSON(value?: WebApiCustomListsDtoUpdateCustomListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'membersEditRights': WebApiModelsEnumerationTypesMembersEditRightsToJSON(value.membersEditRights),
    };
}

